<template>
  <row-action
    icon="EyeIcon"
    :label="label || $t('foundation.rowView')"
    :danger="false"
  />
</template>

<script>
import RowAction from '@/components/foundation/RowAction.vue'

export default {
  name: 'ViewRow',
  components: { RowAction },
  props: { label: { type: String, default: '' } },
}
</script>
